import dayjs from 'dayjs';
import React, { useMemo } from 'react';
import cn from 'classnames';
import { GetV1PrescriptionsElectronicsCanContinueListResponse } from '../../../../../apis/apis';
import styles from './index.module.scss';

interface Props {
  /** 处方信息 */
  prescriptionInfo: GetV1PrescriptionsElectronicsCanContinueListResponse['list'][0];
  /** 选中处方id */
  selectedPrescriptionId: number | undefined;
  /** 选中回调 */
  onSelect: (
    id: GetV1PrescriptionsElectronicsCanContinueListResponse['list'][0]
  ) => void;
}

const PrescriptionCard = (props: Props) => {
  const { prescriptionInfo, selectedPrescriptionId, onSelect } = props;

  const isSelected = useMemo(
    () => selectedPrescriptionId === prescriptionInfo.electronic.id,
    [prescriptionInfo.electronic.id, selectedPrescriptionId]
  );

  return (
    <div className={styles.root} onClick={() => onSelect(prescriptionInfo)}>
      <div
        className={cn({
          [styles.prescriptionWrap]: true,
          [styles.selected]: isSelected,
        })}
      >
        <div className={styles.header}>
          <div className={styles.titleWrap}>
            <div className={styles.title}>处方笺</div>
            <div className={styles.transNo}>
              处方编号：{prescriptionInfo.electronic.transNo}
            </div>
          </div>
          <span className={styles.time}>
            {dayjs
              .unix(prescriptionInfo.electronic.createAt)
              .format('YYYY/MM/DD')}
          </span>
          <div className={styles.diagnose}>
            诊断：<span>{prescriptionInfo.electronic.diagnose}</span>
          </div>
        </div>
        <div className={styles.body}>
          <div className={styles.rp}>RP</div>
          <div className={styles.durgs}>
            {prescriptionInfo?.drugs.map((drug: any) => (
              <div className={styles.drug} key={drug.contentId}>
                <div className={styles.drugName}>{drug.title}</div>
                <div className={styles.specWrap}>
                  <span className={styles.spec}>
                    规格: {drug.specification}
                  </span>
                  数量: ×{drug.quantity}
                </div>
              </div>
            ))}
          </div>
        </div>
        {isSelected && <i className={styles.selected} />}
      </div>
    </div>
  );
};

export default PrescriptionCard;
